import { NewContract } from 'components/contracts/new-contract';

export const NewContractPage = () => {
  return <NewContract />;
};
